import axios from 'axios'
import router from '../router'
// import { Message } from 'element-ui'
const Service = axios.create({
  // 设置超时时间
  timeout: 60000,
  // baseURL: process.env.BASE_URL
  // baseURL: 'http://45.40.254.174:9090/'
  baseURL: 'https://admin.alpschool.com/'
  // baseURL: '/'
})

/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
Service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
Service.interceptors.response.use(
  response => {
    const responseCode = response.status
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (responseCode === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    // 服务器返回不是 2 开头的情况，会进入这个回调
    // 可以根据后端返回的状态码进行不同的操作
    const responseCode = error.response.status
    switch (responseCode) {
      // 401：未登录
      case 401:
        // 跳转登录页
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
        break
        // 403: token过期
      case 403:
        // 弹出错误信息
        // Message({
        //   type: 'error',
        //   message: '登录信息过期，请重新登录'
        // })
        // 清除token
        localStorage.removeItem('token')
        // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        setTimeout(() => {
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
        }, 1000)
        break
        // 404请求不存在
      case 404:
        // Message({
        //   message: '网络请求不存在',
        //   type: 'error'
        // })
        break
        // 其他错误，直接抛出错误提示
      default:
        // Message({
        //   message: error.response.data.message,
        //   type: 'error'
        // })
    }
    return Promise.reject(error)
  }
)
// Service.defaults.headers.post['Content-Type'] =
//   'application/x-www-form-urlencoded'
export const post = (url, data) => {
  return new Service({
    method: 'post',
    url,
    data,
    transformRequest: [function (data) {
      let ret = '';
      for (let it in data) {
        if (typeof data[it] == 'boolean') {
          if (data[it] == true) {
            data[it] = 1;
          } else {
            data[it] = 0;
          }
        } else if (typeof data[it] == 'object') {
          if (it.indexOf("time") > -1 || it.indexOf("birth") > -1) {
            if (data[it] == undefined) {} else if (data[it].length > 1) {
              data[it].forEach(function (value, i) {
                // value = moment(value).format('YYYY-MM-DD HH:mm:ss')
              })
            } else {
              // data[it] = moment(data[it]).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        }
        if (typeof data[it] != 'undefined' && data[it] != undefined) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
      }
      return ret;
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
      // 'Content-Type': 'application/json'
    }
  })
}

// 即设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8

// export default service
